import MissionPriceTypeService from '../../service/missionType';

const Action = {
    GET_MISSION_PRICE_TYPE: "GET_MISSION_PRICE_TYPE",
    GET_MISSION_PRICE_TYPES: "GET_MISSION_PRICE_TYPES",
};

const ActionCreator = {
    getMissionPriceType(missionTypeId) {
        return async (dispatch) => {
            try {
                const missionType = await MissionPriceTypeService.findById(missionTypeId);
                dispatch({type: Action.GET_MISSION_PRICE_TYPE, missionType});
                return missionType;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getMissionPriceTypes() {
        return async (dispatch) => {
            try {
                const missionTypes = await MissionPriceTypeService.list();
                // 將 missionType 限制成跟 minus_type 有關的那 3 種
                const result = missionTypes.map((missionType) => {
                    if (missionType.name.includes('諮詢')) {
                        return {...missionType, is_show: true};
                    } else if (missionType.name === '探視' || missionType.name === '文字諮詢') {
                        return {...missionType, is_show: true};
                    } else {
                        return {...missionType, is_show: false};
                    }
                }).filter((missionType) => {
                    return (missionType.is_show === true);
                });

                dispatch({type: Action.GET_MISSION_PRICE_TYPES, missionTypes: result});
                return result;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
};

const initialState = {
    list: [],
};

const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.GET_MISSION_PRICE_TYPE:
            return {
                ...state,
                ...action.missionType
            };
        case Action.GET_MISSION_PRICE_TYPES:
            return {
                ...state,
                list: action.missionTypes
            };
        default: {
            return state;
        }
    }
};

export default {Action, ActionCreator, Reducer};



// WEBPACK FOOTER //
// ./src/store/actionreducers/missionPriceType.js